import React, { useEffect, useState } from "react";
import { Typography, Box, Card, useTheme } from "@mui/material";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import cliTruncate from "cli-truncate";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import Highlighter from "react-highlight-words";

import AvatarList from "../../AvatarList";
import RightLeftChecker from "../../../../utils/RightLeftChecker";
import { getSettingState } from "../../../../redux/features/settingSlice";
import CustomCircleButton from "../../CustomCircleButton";
import useEnroll from "./../../../../hooks/UseEnroll/index";
import { TableModalHeight } from "../../../../utils/ModalFunc";
// import CustomAvatar from "../../CustomAvatar";
// import digi from "../../../../media/svg/digi.jpg";

const TableCarts = ({ rowData }) => {
  const [openDis, setOpenDis] = useState(false);
  const { searchExplore } = useSelector(getSettingState);
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  let urlParams = location.pathname.split("/");
  let exploreCom = urlParams[1] === "explore";
  const [enrollBtn, setEnrollBtn] = useState(false);
  const [handleEnrollBtn] = useEnroll(rowData?.pk, enrollBtn, setEnrollBtn);
  const modalHeight = TableModalHeight();
  // const badgeHeight = BadgeHeight();

  useEffect(() => {
    rowData && setEnrollBtn(rowData.enrolled);
  }, [rowData]);

  const handleEnroll = (e) => {
    e.stopPropagation();
    handleEnrollBtn();
  };

  const handleNavigate = () => {
    navigate(`/table/${rowData.pk}`);
  };

  const handleOpenDes = (e) => {
    e.stopPropagation();
    setOpenDis(!openDis);
  };

  return (
    <Card
      onClick={handleNavigate}
      sx={{
        border: "2px solid",
        borderColor: "black.main",
        boxShadow: `0px 4px 0px ${theme.palette.black.main}`,
        borderRadius: "16px",
        height: "auto",
        marginBottom: "24px",
        cursor: "pointer",
      }}
    >
      <Box
        width='100%'
        height='auto'
        style={{
          zIndex: 1,
          backgroundImage: `url(${rowData.banner})`,
          height: `${modalHeight}px`,
          backgroundSize: "101%",
          backgroundRepeat: "no-repeat",
        }}
      />

      {/* Sponsor Tag  */}
      {/* {rowData.pk === 7 && (
        <Box sx={{ position: "relative" }}>
          <Box
            sx={{
              backgroundColor: "white.main",
              width: "108px",
              height: "24px",
              position: "absolute",
              borderRadius: "8px",
              bottom: `${badgeHeight}px`,
              left: "14px",
            }}
          >
            <Box
              sx={{
                fontSize: "12px",
                display: "flex",
                height: "100%",
                alignItems: "center",
                pl: "6px",
                pt: "2px",
              }}
            >
              Sponsored by{" "}
              <Box sx={{ ml: "4px", mb: "2px" }}>
                <CustomAvatar
                  link={"/profile/Digikala"}
                  borderSize={2}
                  size={"15px"}
                  src={digi}
                  alt={"digikala"}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      )} */}
      <Box
        sx={{
          padding: "16px",
          // backgroundColor: "white.main",
          width: "100%",
        }}
      >
        {/* <Box
          sx={{
            mt: "auto",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "end",
            mb: "12px",
          }}
        >
          <Typography sx={{ color: "mute.main", fontSize: "13px" }}>
            {rowData.category.name}
          </Typography>
          <Typography sx={{ color: "mute.main", fontSize: "13px" }}>
            Started at {moment(rowData.created_at).format("DD/MM/YYYY")}
          </Typography>
        </Box> */}
        <Typography
          sx={{
            fontFamily: "Tahrir",
            fontWeight: "700",
            lineHeight: "32px",
            fontSize: "27px",
            marginBottom: "8px",
            color: "black.main",
            direction: RightLeftChecker(rowData.title) ? "rtl" : "ltr",
          }}
        >
          {exploreCom ? (
            <Highlighter
              unhighlightStyle={{ fontWeight: "700", color: "black.main" }}
              highlightClassName='highlight'
              searchWords={[searchExplore]}
              autoEscape={true}
              textToHighlight={cliTruncate(rowData.title, 56)}
            />
          ) : (
            cliTruncate(rowData.title, 56)
          )}
        </Typography>
        <Box
          onClick={handleOpenDes}
          sx={{
            display: "flex",
            direction: RightLeftChecker(rowData.description) ? "rtl" : "ltr",
          }}
        >
          <Box
            sx={{
              fontSize: "16px",
              marginBottom: "8px",
              color: "black.main",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: openDis ? "normal" : "nowrap",
            }}
          >
            {exploreCom ? (
              <Highlighter
                highlightClassName='highlight'
                searchWords={[searchExplore]}
                autoEscape={true}
                textToHighlight={rowData.description}
              />
            ) : (
              <>
                {rowData.description}
                {openDis && rowData.description.length > 40 && (
                  <Typography
                    sx={{
                      display: "inline-flex",
                      fontSize: "16px",
                      lineHeight: "24px",
                      fontWeight: 600,
                      color: "black.main",
                      px: "6px",
                    }}
                  >
                    Less
                  </Typography>
                )}
              </>
            )}
          </Box>
          {!openDis && rowData.description.length > 40 && (
            <Typography
              sx={{
                fontSize: "16px",
                lineHeight: "24px",
                fontWeight: 600,
                color: "black.main",
              }}
            >
              More
            </Typography>
          )}
        </Box>

        <Box
          sx={{
            borderTop: "2px solid",
            borderColor: "black.main",
            marginTop: "16px",
            paddingTop: "8px",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <AvatarList type='table' avatarData={rowData} size={24} />

            <Box sx={{ textAlign: "right" }}>
              <CustomCircleButton
                className='t-follow'
                width='26px'
                height='26px'
                onClick={handleEnroll}
                bgColor={enrollBtn ? "black.main" : "primary.main"}
                color={enrollBtn ? "white.main" : "black"}
                hoverBgColor='primary.main'
                hoverColor='black.main'
                activeBgColor='black.main'
                activeColor='white.main'
                bShadow={
                  enrollBtn ? "none" : `0px 2px 0px ${theme.palette.black.main}`
                }
              >
                {enrollBtn ? (
                  <DoneRoundedIcon sx={{ fontSize: "20px" }} />
                ) : (
                  <AddRoundedIcon sx={{ fontSize: "20px" }} />
                )}
              </CustomCircleButton>
            </Box>
          </Box>
        </Box>
      </Box>
    </Card>
  );
};
export default TableCarts;
